var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.4062 11.0625C15.2812 10.9375 15.0938 10.9375 14.9688 11.0625L12.2188 13.7812L11.0312 12.5938C10.9062 12.4688 10.6875 12.4688 10.5938 12.5938L9.84375 13.3125C9.71875 13.4375 9.71875 13.625 9.84375 13.75L11.9688 15.9062C12.0938 16.0312 12.3125 16.0312 12.4062 15.9375L16.125 12.25C16.25 12.125 16.25 11.9375 16.125 11.8125L15.4062 11.0625ZM17.5 6H15C15 4.90625 14.0938 4 13 4C11.875 4 11 4.90625 11 6H8.5C7.65625 6 7 6.6875 7 7.5V18.5C7 19.3438 7.65625 20 8.5 20H17.5C18.3125 20 19 19.3438 19 18.5V7.5C19 6.6875 18.3125 6 17.5 6ZM13 5.5C13.25 5.5 13.5 5.75 13.5 6C13.5 6.28125 13.25 6.5 13 6.5C12.7188 6.5 12.5 6.28125 12.5 6C12.5 5.75 12.7188 5.5 13 5.5ZM17.5 18.25C17.5 18.4062 17.375 18.5 17.25 18.5H8.75C8.59375 18.5 8.5 18.4062 8.5 18.25V7.75C8.5 7.625 8.59375 7.5 8.75 7.5H10V8.5C10 8.78125 10.2188 9 10.5 9H15.5C15.75 9 16 8.78125 16 8.5V7.5H17.25C17.375 7.5 17.5 7.625 17.5 7.75V18.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.0e363ac51eea7d714606fa9e7d53b169.svg";
export { ForwardRef as ReactComponent };